export default "__VITE_ASSET__BP0VM$LV__"